import { ApiUpdate, ApiPreSignedUrl, ApiPage } from "./api_data";
import { Ajax } from "../../shared/ajax";
import { App } from "./app";
import { Page } from "./page";

export interface UpdateOpts {
  update_thumbnail: boolean;
  data_changes: boolean;
}

export class Api {

  static thumbnail_upload_urls: { [id: string]: string } = {};
  static thumbnail_retry = 0;
  static presigned_url_retry = 0;

  static update_page(page: Page, changes: ApiUpdate, update_thumbnail: boolean = false) {
    const path = "/api/v1/pages/" + page.id;
    Ajax.put(path, function (data: ApiPage) {
      for (const k in App.page_sets) {
        if (App.page_sets.hasOwnProperty(k)) {
          const set = App.page_sets[k];
          for (const set_page of set) {
            if (set_page.id === page.id) {
              set_page.version = data.version;
              set_page.connections = data.connections;
              set_page.attributes = data.attributes;
              break;
            }
          }
        }
      }

    }, changes, function (code: number, data: any) {
      console.log("api error: ", code, data);
    });
    if (update_thumbnail) {
      App.new_graph_data = true;
      App.thumbnail_dirty_count = 1;
    }
  }

  static update_display(display_id: string, changes: ApiUpdate, opts?: UpdateOpts) {
    const path = "/api/v1/displays/" + display_id;
    Ajax.put(path, function () {
      //
    }, changes, function (code: number, data: any) {
      console.log("api error: ", code, data);
    });

    let update_thumbnail = true;
    let data_changes = true;
    if (opts !== undefined) {
      update_thumbnail = opts.update_thumbnail;
      data_changes = opts.data_changes;
    }
    if (update_thumbnail) {
      App.thumbnail_dirty_count++;
    }
    if (data_changes && App.selected_page) {
      for (const v of App.selected_page.viz_list) {
        if (v.viz.id === display_id) {
          v.viz.data_changes = true;
        }
      }
    }
  }

  static get_pre_signed_url(page_id: string, cb: Function) {
    const url = "/api/v1/pages/" + page_id + "/pre_signed_url";
    Ajax.get(url, function (data: ApiPreSignedUrl) {
      cb(data);
    });
  }

  static upload_thumbnail(page_id: string, data: Blob) {
    App.new_graph_data = false;
    const url = Api.thumbnail_upload_urls[page_id];
    if (url === undefined) {
      if (Api.presigned_url_retry < 3) {
        Api.presigned_url_retry++;
        Api.get_pre_signed_url(page_id, function (url_data: ApiPreSignedUrl) {
          Api.thumbnail_upload_urls[page_id] = url_data.url;
          Api.upload_thumbnail(page_id, data);
        })
      }
      return;
    }
    Api.presigned_url_retry = 0;
    const request = new XMLHttpRequest();

    const retry = function () {
      console.log('thumbnail error');
      console.log(request.status, request);
      if (Api.thumbnail_retry < 2) {
        delete Api.thumbnail_upload_urls[page_id];
        Api.thumbnail_retry++;
        Api.upload_thumbnail(page_id, data);
      }
    }

    request.onload = function () {
      if (request.status >= 200 && request.status < 400) {
        Api.thumbnail_retry = 0;
        App.thumbnail_dirty_count = 0;
      } else {
        retry();
      }
    };
    request.onerror = function () {
      retry();
    };
    request.open('PUT', url, true);
    request.setRequestHeader("Content-Type", "image/png");
    request.send(data);
  }
}